import moment from 'moment';
import storage from './storage';
import { USER_ID, TOKEN } from './constants/cookies';

const getFormValues = (target, fields = []) => {
  const form = target;
  const data = {};

  fields.forEach((fieldName) => {
    if (form[fieldName]) {
      const type = form[fieldName].dataset.component;
      let val = null;

      if (type === 'text-input') {
        val = form[fieldName].value;
      }

      if (type === 'numeric-input') {
        let { value } = form[fieldName];
        // check for prefix and suffix
        if (form[fieldName].dataset.suffix) {
          value = value.replace(form[fieldName].dataset.suffix, '');
        }

        if (form[fieldName].dataset.prefix) {
          value = value.replace(form[fieldName].dataset.prefix, '');
        }

        val = Number(value);
      }

      if (type === 'numeric-input-toggle-button') {
        let { value } = form[fieldName];
        // const trailBase = form[fieldName].dataset['data-trail-base'];
        // check for prefix and suffix
        if (form[fieldName].dataset.suffix) {
          value = value.replace(form[fieldName].dataset.suffix, '');
        }

        if (form[fieldName].dataset.prefix) {
          value = value.replace(form[fieldName].dataset.prefix, '');
        }

        value = Number(value);

        const trailBase = form[fieldName].dataset['trailbase'];
        const isTrailing = form[fieldName].dataset['trail'];

        if (trailBase === '1' && isTrailing === 'true') {
          value = -1 * Number(value);
        } else if (trailBase === '-1' && isTrailing === 'false') {
          value = -1 * Number(value);
        } else {
          value = Number(value);
        }

        val = Number(value);
      }

      if (type === 'select') {
        val = form[fieldName].dataset.value;
      }

      if (type === 'date-picker') {
        val =
          moment(`${form[fieldName].value}`, 'DD/MM/YYYY') &&
          moment(`${form[fieldName].value}`, 'DD/MM/YYYY')
            .startOf('day')
            .valueOf()
            ? moment(`${form[fieldName].value}`, 'DD/MM/YYYY')
                .startOf('day')
                .valueOf()
            : null;
      }

      // if (type === 'radio') {
      //   console.log(form[fieldName].value);

      //   // val = form[fieldName].dataset.value;
      // }

      data[fieldName] = val;

      // Radio
    } else if (form.querySelector(`[data-radio-name="${fieldName}"]:checked`)) {
      const component = form.querySelector(
        `[data-radio-name="${fieldName}"]:checked`
      );

      data[fieldName] = component.value;
    } else if (
      form.querySelector(`[data-checkbox-name="${fieldName}"]:checked`)
    ) {
      const component = form.querySelector(
        `[data-checkbox-name="${fieldName}"]:checked`
      );

      data[fieldName] = component.value;
    } else if (form.querySelector(`[data-name="${fieldName}"]`)) {
      const component = form.querySelector(`[data-name="${fieldName}"]`);
      const type = component.dataset.component;
      let val = null;

      if (type === 'button-toggle') {
        val = component.dataset.value;
      }

      data[fieldName] = val;
    } else {
      data[fieldName] = null;
    }
  });

  return data;
};

export const getValuesFromSubmittedForm = (e, fields = []) => {
  const form = e.target;

  return getFormValues(form, fields);
};

export const readFormFields = (target, fields = []) => {
  return getFormValues(target, fields);
};

export const writeBuffer = (name, data) => {
  sessionStorage.setItem(name, JSON.stringify(data));
};

export const readBuffer = (name) =>
  sessionStorage.getItem(name)
    ? JSON.parse(sessionStorage.getItem(name))
    : null;

export const getFormattedDateFromDateObject = (
  dateObj,
  format = 'DD/MM/YYYY'
) => {
  return moment.utc(dateObj).utcOffset('+05:30').format(format);
};

export const getFormattedDateFromTimestamp = (
  timestamp,
  format = 'DD/MM/YYYY'
) => {
  return moment.utc(timestamp).utcOffset('+05:30').format(format);
};

export const dateMoment = (val = null) =>
  val ? moment.utc(val).utcOffset('+05:30') : moment.utc().utcOffset('+05:30');

export const getFormattedDate = (val = null, format = 'DD-MM-YYYY') =>
  dateMoment(val).format(format);

export const formatDataForLineChartSimple = (dataArr) => {
  const newDataArr = [];
  dataArr.forEach(({ x, y }) => {
    const timeMoment = moment(`${x} 00:00:00 +05:30`, 'DD-MM-YYYY HH:mm:ss zz');

    newDataArr.push({
      time: timeMoment.format('YYYY-MM-DD'),
      value: y,
    });
  });

  return newDataArr;
};

// {x: "03-02-2020", y: 3907}
// time: '2018-10-19', value: 52.89

const getParams = (param) => {
  const urlParams = new URLSearchParams(window.location.search);

  return urlParams.get(param);
};

export const catchReferal = () => {
  const getReferral = getParams('referral');
  const getSignedUpVia = getParams('signedUpVia');

  if (getReferral && getReferral !== '') {
    return {
      field: 'referral',
      value: getReferral,
    };
  } else if (getSignedUpVia && getSignedUpVia !== '') {
    return {
      field: 'signedUpVia',
      value: getSignedUpVia,
    };
  }

  return null;
};

export const efficientSetInterval = (func, timeout, options = {}) => {
  const { leading = false, waterfall = false } = options;

  const timerFunc = () => {
    setTimeout(() => {
      if (waterfall) {
        requestAnimationFrame(() => {
          const funcPromise = Promise.resolve(func.call());
          requestAnimationFrame(() => funcPromise.finally(timerFunc));
        });
        return;
      }

      requestAnimationFrame(() => {
        func.call();
      });
      requestAnimationFrame(timerFunc);
    }, timeout);
  };

  requestAnimationFrame(timerFunc);

  if (leading) {
    func.call();
  }
};

export const clearCookies = () => {
  storage.deleteItem(TOKEN);
  storage.deleteItem(USER_ID);
  sessionStorage.removeItem('algoInfo');
  storage.deleteItem('expiryWarningClosedAt');
};

export function getCurrentPageAsSearchParam() {
  const page = window.location.href.replace(window.location.origin, '');
  const encoded = encodeURI(page);

  return encoded || '';
}

export function getResumePageFromParams() {
  const urlParams = new URLSearchParams(window.location.search);
  const hash = window.location?.hash || '';
  const resumePage = decodeURI(urlParams.get('resume') || '');

  return `${resumePage}${hash}`;
}

export const forcedLogout = () => {
  clearCookies();

  setTimeout(() => {
    window.location.reload();
  }, 400);
};

export const intendedLogout = () => {
  clearCookies();

  setTimeout(() => {
    window.location.reload();
  }, 400);
};

export const capitalizeText = (phrase = '', ignoreList = ['and']) => {
  return phrase
    .toLowerCase()
    .split(' ')
    .map((word) =>
      ignoreList.includes(word)
        ? word
        : word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join(' ');
};

export const isCurruntLegStatusClosedFromLiveData = (
  positionsState = {},
  id = ''
) => {
  const { positions: positionsLiveData = [] } = positionsState;
  let pos = positionsLiveData.filter((p) => p.id === id) || [];

  pos = pos.map(({ status = '' }) => status);

  return pos.length && pos.every((status) => status === 'CLOSE') ? true : false;
};

export const getMomentFromTimestamp = (timestamp) => {
  return moment.utc(timestamp).utcOffset('+05:30');
};

export const getMomentFromCurruntTime = () => {
  return moment.utc().utcOffset('+05:30');
};

export const getDateFromMoment = (moment) => {
  return moment.utc().utcOffset('+05:30').toDate();
};

export const getMomentFromDate = (date) => {
  return moment(date);
};

const getDaysArrayFormatCallBack = (date) => {
  return date.format('DD-MM-YYYY');
};

export const getDaysArray = (
  from,
  to,
  interval = 1,
  formatCallBack = getDaysArrayFormatCallBack
) => {
  let ret = [];

  const fromDate = moment(from, 'DD-MM-YYYY')
    .startOf('day')
    .subtract(1, 'days');

  const toDate = moment(to, 'DD-MM-YYYY').startOf('day').add(1, 'days');

  let date = fromDate.add(interval, 'days');

  while (toDate > date) {
    ret.push(formatCallBack(date));
    date = moment.utc(date).utcOffset('+05:30').add(interval, 'days');
  }

  return ret;
};

const getRequestedString = (string = 'X', times = 1) => {
  let toReturn = '';

  for (let counter = 1; counter <= times; counter++) {
    toReturn += string;
  }

  return toReturn;
};

export const getBlurredText = (text = '', replaceBy = 'X') => {
  const textLength = text.length;

  return getRequestedString(replaceBy, textLength);
};

// const { round } = require('@quantiply/common/utils');
export const round = (number, precision = 2) => {
  const factor = 10 ** precision;
  const tempNumber = number * factor;
  const roundedTempNumber = Math.round(tempNumber);
  return roundedTempNumber / factor;
};
